/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-idea': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M6.875 15h6.25v1.25h-6.25V15zm1.25 2.5h3.75v1.25h-3.75V17.5zM10 1.25A6.25 6.25 0 003.75 7.5a5.744 5.744 0 002.162 4.762c.625.582.963.913.963 1.488h1.25c0-1.15-.694-1.794-1.369-2.412A4.5 4.5 0 015 7.5a5 5 0 0110 0 4.5 4.5 0 01-1.762 3.838c-.67.625-1.363 1.25-1.363 2.412h1.25c0-.575.331-.906.963-1.494A5.738 5.738 0 0016.25 7.5 6.25 6.25 0 0010 1.25z"/>'
  }
})
